// extracted by mini-css-extract-plugin
export default {"deleteButton":"style_deleteButton__7N++5"};